export const userMock = {
  "address": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
  "name": "Example Profile",
  "github": "",
  "twitter": "",
  "website": "",
  "aum": null,
  "totalAum": null,
  "createdAt": null,
  "description": "",
  "avatar": "",
  "personalInfo": {},
  "totalDaos": 23,
  "totalOrgs": 23,
  "totalProposals": 33,
  "totalVotes": 825,
  "participationScore": 308.00856398004,
  "relativeScore": 99.99997837331578,
  "participationScoreRank": 4,
  "daos": [
      {
          "daoId": "9209fc8d-d310-462c-980d-623b4319aee6",
          "organizationId": "018d37fd-bcf9-4582-8113-4f48184a973c",
          "name": "SharedStake",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/018d37fd-bcf9-4582-8113-4f48184a973c.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "d4697601-b4e5-4bc5-94bf-75c61d77271f",
          "organizationId": "01fe9d91-e697-4319-aac7-47c83cb2dd45",
          "name": "Sismo",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/01fe9d91-e697-4319-aac7-47c83cb2dd45.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "d6e07081-8055-4100-ba26-c84a54361e45",
          "organizationId": "05084b74-1f49-4524-8d4f-20a02dfe1b2d",
          "name": "WagameDAO",
          "image": null,
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "377b0505-f90a-4baf-9b17-ed2af6a0a204",
          "organizationId": "058539fe-2e08-4e7a-9689-4dd05e237c11",
          "name": "Starknet",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/058539fe-2e08-4e7a-9689-4dd05e237c11.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "d5407e31-296a-47f6-ba91-3ad42aaa771c",
          "organizationId": "0c06f49b-0655-4858-9e18-b5cfa1447059",
          "name": "GMX",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/0c06f49b-0655-4858-9e18-b5cfa1447059.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "02b8d47b-88d1-49ee-a0e0-9fdfdf0858ff",
          "organizationId": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "name": "Optimism",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/10edb97a-9dba-448a-88b1-ca263a7c75ad.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "5983fe45-b504-427c-bfce-fa4f4bc66383",
          "organizationId": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
          "name": "Polygon",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/4a8d7f3c-844a-4039-949d-7b748d3242e0.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "9ca29d7b-921e-4750-b5bb-bf5fedcc9022",
          "organizationId": "516aeb46-334a-42d2-8f84-7f1330d75445",
          "name": "PlutusDAO",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/516aeb46-334a-42d2-8f84-7f1330d75445.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "403930f9-4c53-423b-8ac9-d2715e518d48",
          "organizationId": "5483d5a1-e52c-491b-a8c8-9c8db0eff08d",
          "name": "Bonsai / Umami DAO",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5483d5a1-e52c-491b-a8c8-9c8db0eff08d.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "bc2232d1-035d-486d-afac-670b61ef254b",
          "organizationId": "674d4a02-b163-4405-938d-e6958c39a477",
          "name": "Mycelium",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/674d4a02-b163-4405-938d-e6958c39a477.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "c6b848a1-4435-4743-b17c-1e685b39bf91",
          "organizationId": "7440c4e5-676d-4c53-8d65-46ead9457125",
          "name": "Galleon",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/7440c4e5-676d-4c53-8d65-46ead9457125.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "3c6c21a1-a8f4-4079-9995-691636296ba2",
          "organizationId": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
          "name": "SafeDAO",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/8880b84d-f3e2-49d0-b50d-0b6d338c0ffc.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "e7324a5e-cbc3-4cb2-b2b9-e9ee4b680fc9",
          "organizationId": "8cc47436-456b-42a4-9002-e45630c74fed",
          "name": "EMS",
          "image": null,
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "a115cc50-5851-4607-8286-2041511d5faa",
          "organizationId": "a98566cd-9eb7-4031-98e2-a53453981fa2",
          "name": "Connext",
          "image": null,
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "63d8eb8a-f321-4815-8a57-45e380977b07",
          "organizationId": "ae7f0c34-4e9f-4543-b777-b5ac759dd5a6",
          "name": "Anti-Capture Commission",
          "image": null,
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "21365cdd-644a-4820-90a4-7c992300c651",
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "name": "Arbitrum",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b29f3be3-d4c7-4401-92cd-73390f09816b.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "8fd8ff5b-022e-4bbc-b863-8e85fa73780f",
          "organizationId": "b93b0ded-7648-45c9-86fb-cca48090431a",
          "name": "Cultivator DAO",
          "image": null,
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "a0e97e6c-0c1f-4eee-922b-65fdc599cb42",
          "organizationId": "d13f96a0-da32-47ce-841a-96134e8459eb",
          "name": "Stargate Finance",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d13f96a0-da32-47ce-841a-96134e8459eb.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "ec19bafa-1290-49e1-be21-85541ab9e996",
          "organizationId": "d4f98fb1-20a9-4bd1-9e4f-0214bedcc99d",
          "name": "Diva Staking",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1689238569380DivaStaking",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "6a42594e-731c-4512-8111-dbd534bf43e6",
          "organizationId": "da93b2c3-2298-4d28-bcbb-22df3948b24a",
          "name": "Vesta Finance",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/da93b2c3-2298-4d28-bcbb-22df3948b24a.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "3c882774-4056-46a3-89f8-d3ed9b2225f2",
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "name": "Hop DAO",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/f50de02c-382c-4527-b462-eaf4ac538c18.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "8257a812-5661-4394-bfeb-ab2556a15a37",
          "organizationId": "fd69e3b7-d2c8-4d1f-bd04-5fd48160b6e5",
          "name": "Jones DAO",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fd69e3b7-d2c8-4d1f-bd04-5fd48160b6e5.webp",
          "membersAmount": null,
          "proposalsAmount": null
      },
      {
          "daoId": "4820175d-298a-4140-897f-f1221973b4ea",
          "organizationId": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "name": "Uniswap",
          "image": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28.webp",
          "membersAmount": null,
          "proposalsAmount": null
      }
  ],
  "tokens": []
};

export const userLabelsMock = {
  "data": {
      "labels": [
          {
              "id": "2f440859-96bb-4916-9c0f-afbfe18db1b6",
              "name": "DAO Voter"
          },
          {
              "id": "a46f5b48-420c-43ad-98c9-cd5ccf39711c",
              "name": "Top 1% Voter"
          },
          {
              "id": "2898c2a2-1d6d-41ae-93e9-e43f1e75d5a5",
              "name": "Top 5% Voter"
          },
          {
              "id": "e73a2d30-1743-4815-b6c6-ee0f536da357",
              "name": "DAO voter 2022"
          },
          {
              "id": "34d7200b-bd19-45cd-a27e-87243c03e5a0",
              "name": "DAO voter 2023"
          },
          {
              "id": "df5083de-125f-4e79-94e4-9eb9a260119f",
              "name": "DAO voter 2024"
          },
          {
              "id": "1ead677e-7804-4fd8-ac88-d764b9936862",
              "name": "Delegate"
          },
          {
              "id": "18bccaf7-df15-4ec8-afdb-2b7a03e665ea",
              "name": "Delegator"
          },
          {
              "id": "61a2e3ac-54a9-45e7-b93f-fe317050dba0",
              "name": "Multiple Delegate"
          },
          {
              "id": "1c64cdb3-a457-4f28-a63d-7c85cf1a3f31",
              "name": "Multiple Delegator"
          },
          {
              "id": "9094aa7a-eee2-427d-a5fb-c39d6f722de2",
              "name": "DeFi Voter"
          },
          {
              "id": "8346293b-95d6-4555-b5e2-f4165d7daeca",
              "name": "Infrastructure Voter"
          },
          {
              "id": "9a71a8d2-e74d-48f1-abbc-8c4d8ce2808f",
              "name": "Work & Funding Voter"
          },
          {
              "id": "33b56560-87ef-44b9-9fcd-8bb782eb0d95",
              "name": "Offchain voter 2022"
          },
          {
              "id": "434c77eb-6166-4b2c-ad26-824b07cb5ee3",
              "name": "Offchain voter 2023"
          },
          {
              "id": "ead01c89-fac9-4ace-8b56-e83bf8fce92f",
              "name": "Offchain voter 2024"
          },
          {
              "id": "23a3c608-982b-43c9-a11f-ecc7828825a9",
              "name": "Onchain voter 2022"
          },
          {
              "id": "6e3a46fd-2168-422e-840a-9a8f3e1e412e",
              "name": "Onchain voter 2023"
          },
          {
              "id": "44f756e1-c641-49fb-b9ad-089859343bcd",
              "name": "Onchain voter 2024"
          },
          {
              "id": "6245373d-296b-49f0-a4e2-5b956bbafdd3",
              "name": "Proposal Creator"
          },
          {
              "id": "fba12317-344c-4da7-9fca-974779e8e1bb",
              "name": "Ten Organizations voter"
          }
      ],
      "gScore": 99.99997837331578,
      "gScoreRanking": 4
  }
};

export const userProposalsMock = {
  "f50de02c-382c-4527-b462-eaf4ac538c18": [
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-41] Incentivize Hop AMMs on Supported and Upcoming Chains",
          "status": "ACCEPTED",
          "createdAt": "2023-12-18T15:59:39.000Z",
          "proposalNativeId": "0x8741b91e1a926f609d423ceff4a2b39b2a93f3c7f4f168c050418184f43b3848",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "# [HIP-39] Community Multisig Refill (3)\nThe Hop Community Multisig has continued to distribute payments for the Hop DAO to delegates, multisig signers, bonders, and AMM reward contracts (liquidity incentives).\n\nPer HIP-15, this distribution, as well as future distributions to refill the multisig will be refilled via on-chain governance vote every other month.\n\nHIP-18 proposed refilling the HOP community multisig with approximately 4 months of supply. Part of that proposal was to bypass the forum RFC and go straight to snapshot for subsequent refills, assuming there is no material changes to the structure.\n\nHere is the community multisig (https://app.safe.global/balances?safe=eth:0x60224984338DeDe521C56DEE7a09e446A5a163f4) . This should be refilled with HOP to provide 4 months runway under the same logic as HIP-18.",
          "status": "ACCEPTED",
          "createdAt": "2023-10-09T18:36:35.000Z",
          "proposalNativeId": "0xed8bdb5895b8b7f9fdb3c087628fd8410e853d48-proposal-870532",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": null
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "# [HIP-38] Treasury Diversification\n### Summary\nSell 50% of Hop DAO’s ARB holdings (837,007 ARB) for USDC. This should raise approximately $686k for Hop DAO at current prices (~$0.82).\n\n### Motivation\nHop DAO will need stablecoins to cover ongoing expenses. This sale would be an initial step toward the broader goal of treasury diversification.\n\n### Execution\nBefore an onchain vote, a deployment of the Hop Community Multisig should be deployed on Arbitrum. The onchain execution of the proposal will send a message through the Arbitrum messenger to trigger a transfer of the ARB currently in the Hop Treasury alias 6 address to the Community Multisig. The Community Multisig can then complete the sale in a series of transactions.\n\n### Voting Options\nSell 50% of Hop DAO’s ARB holdings for USDC\nNo action\nAbstain\n\n",
          "status": "ACCEPTED",
          "createdAt": "2023-10-09T18:35:59.000Z",
          "proposalNativeId": "0xed8bdb5895b8b7f9fdb3c087628fd8410e853d48-proposal-978695",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": false,
          "voteChoice": 2,
          "choices": null
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "# [HIP-30] HOP Airdrop Sybil Hunter Distribution\n`Authors: @shanefontaine`\n\n# Overview\nWhen the Hop DAO was launched, Sybil hunters submitted reports that ultimately removed Sybil attackers from the HOP airdrop, resulting in the DAO keeping almost 3.5 million tokens that would have otherwise been in the hands of Sybil attackers. Per the Hop DAO introduction post, this proposal seeks to reward these Sybil hunters with 25% of the saved tokens now, a year after the start of the DAO.\n\nBeyond the direct benefits of token recovery, the Sybil hunters also contributed to promoting the DAO in indirect ways. Both the SAFE airdrop and the Arbitrum airdrop adopted elements of Hop’s airdrop design as a result of the hunters’ effort and innovation, thus validating and enhancing the DAO’s influence. Each of those teams specifically called out Hop as inspiration during their airdrop process.\n\n# Specific Details\nTotal tokens to distribute: 869,566.51\nTotal recipients: 35\nDistribution method: The DAO will send funds to an OpenZeppelin PaymentSplitter contract that allows the addresses to claim tokens sent to the contract. The address of the verified contract is 0xD62524e1Bd146AB1a8e3D03ea8646870E3684fEe . The contract claim start time will be Fri Jun 09 2023 10:48:36 GMT+0000, which is the same start time as all of the HOP vesting contracts created at the beginning of the DAO’s lifetime.\n\n# Next Steps\nBased on the process defined in HIP-13 , this RFC will move from the forum to a proposal on Snapshot and subsequently onto Tally, assuming consensus is reached at each stage.\n\n# References\n* [Hop DAO introduction post](https://hop.mirror.xyz/AI5fOUR0X_l0mktShDOx3mwr-hsB24gp8GvTWtS-MBc)\n* [Sybil hunter submissions](https://github.com/hop-protocol/hop-airdrop)\n* [Twitter overview thread](https://twitter.com/WhinfreyChris/status/1525178626563420160)\n* Distribution (table below)\n\n```\nRecipient Address\tHOP Amount\n0x945D28dF9779795BDab5BC6FDD9f36c0Ef1F7190\t93,050.37\n0xBCCD7DF161C0d155D3E56D8C57Cc31C185217546\t29,441.94\n0xb33e018fd80466E46Cb0d52F46eA98105E7B53ec\t6,955.00\n0x61C1511D2645C1Fd1C5e71f07586d35779D85D79\t9,715.53\n0x0c31Fb1f6035402d61c6B4b0a5c2B62309fF763d\t14,740.59\n0x87122A072DaCF42bcCA5F4583fF08dEd2fb89176\t13,821.37\n0xa52AaF7da0156d2D30a310aFe6f084a0DA9cEE54\t6,724.63\n0x400aBc3DAE98Ec5aEEF2681b40D4CEd0A5aff934\t106,850.36\n0x414DD753dEa0c34f83695Cea8FdD38d734E49b4E\t17,335.98\n0xFB7c1D49e006eaDdff2385c7eF8B0C5Cf49d038A\t3,406.56\n0x7d3f6048091aEdE6198736b8C6ac527c314e25ff\t71,439.55\n0x0A304d8B62488766b0B4004C6398F5f439c45afa\t3,096.38\n0x572Ae335AaC8F32DC1ac53B97Fe248C3c9B3aF77\t4,397.15\n0x0BE6FC06A0A605D006C6317E5b0383F6Fb1394F1\t51,826.21\n0x68C589fAb487f2F100d0380Fad9648263F2e7145\t41,246.28\n0x386f6B908640d9f394EF37bC1b8c3a4018fa3dB1\t15,515.27\n0x12FB89D601C674aeA4d91f92ABD30eB9bb57a95E\t2,367.41\n0x7D389CfcD35e2aE40599b2662040A32E1450E6D6\t6,392.06\n0x987ffC303bEa07c4aD724f2BA9800b1FDC6a7dB0\t24,519.63\n0x6147B20E2542137055C87E6d86C8af5bF8Fb515a\t4,062.73\n0xdaa2fAA20484ef193F4678a802cEa58750638B2A\t39,163.63\n0xF1e4FbbC580Fc71714EfA23F352E6A70eBe46D39\t16,082.46\n0x61bC799fD0EB6C791E1cF22E1e9908635444d5A6\t48,662.07\n0xab41733192b401c88f3c0e42cacab44365530fba\t2,894.44\n0xD47CB1835EB36e4A108C33E446449192426Fc160\t136,043.68\n0x7F5F2980A85B363BD9013593A3D8b4f7DB3781Fd\t3,542.76\n0x0fB267a11d0a4ee611a3A8Dc41147A5729276161\t3,596.69\n0x5c43B1eD97e52d009611D89b74fA829FE4ac56b1\t13,983.16\n0x93CbB09b82b429e0566D1ca3596515DDAeF1980A\t8,816.78\n0x516d03de90f3Df147861E8d8001c8EDc79d89Ce7\t2,859.99\n0x9bb82fbf10cF4959909BAB9bE07805bd1d28D04A\t28,821.95\n0x99EdCfb867E9772384f3b560fE360d1530d6740d\t7,562.27\n0x72153F1040BDfe6961bB73448f1AF265B2bFDf0b\t7,157.50\n0x5E14E0c2e39ae6d65e33D21edA41796f4db86d52\t17,354.19\n0x6a1AF72bBcfD0BA492E502F83334d3910Fa025dB\t6,119.94\n```",
          "status": "ACCEPTED",
          "createdAt": "2023-06-06T21:39:35.000Z",
          "proposalNativeId": "0xed8bdb5895b8b7f9fdb3c087628fd8410e853d48-proposal-101932",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": null
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-27] Launch Hop on Polygon zkEVM Mainnet",
          "status": "ACCEPTED",
          "createdAt": "2023-04-13T10:40:33.000Z",
          "proposalNativeId": "0x3b59bfaf298282c45d088ff972e4d641c649fe60532c29bf7c6ed3b798e1c7ea",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-25] Lito Departure",
          "status": "ACCEPTED",
          "createdAt": "2023-04-10T20:24:05.000Z",
          "proposalNativeId": "0x4d340caf3061d3bdb106ce3a184c7c9e54ba665c6dd719282d61cbecc179cb55",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-23] - Proposal to deploy HOP on Scroll zkEVM",
          "status": "ACCEPTED",
          "createdAt": "2023-03-17T17:49:30.000Z",
          "proposalNativeId": "0x60f20dd661e7ed90a0d08cf941c72f26fc6dc585526f0fe7ca1339851959406a",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "# HIP 18: Refill The HOP Community Multisig with Funds from the HOP DAO\n```\n[HIP-18]: Refill The HOP Community Multisig with Funds from the HOP DAO\n[Author]: Shane Fontaine\n[Snapshot vote]: https://snapshot.org/#/hop.eth/proposal/0x3e81e9581f48b150787a5160c3dfc65d4947ff4206e6cdca053d16da0bc60a77\n```\n### \n### Proposal\n\nThe [HOP Community Multisig](https://etherscan.io/address/0x60224984338dede521c56dee7a09e446a5a163f4) has efficiently distributed payments for the HOP DAO since its inception. These distributions have been made to [delegates](https://snapshot.org/#/hop.eth/proposal/bafkreic3hu4fhna7lfyecwvvasfqccygzhpkvw2zu4mihzglccwa5om6ii), [multisig signers](https://snapshot.org/#/hop.eth/proposal/0x15937d80591ed226743226721d236e8c9190461521c866f18a45cb9703773a22), [bonders](https://snapshot.org/#/hop.eth/proposal/bafkreicliwx2wt4rnjbappi4yyk4z2qrh224guatw7z3uo3wwh7ruekeee), and [AMM reward contracts](https://snapshot.org/#/hop.eth/proposal/bafkreicliwx2wt4rnjbappi4yyk4z2qrh224guatw7z3uo3wwh7ruekeee) (in the form of liquidity incentives).\n\nThe multisig initially received [20,000,000 HOP](https://etherscan.io/tx/0xa2bbae45a9a184e4555c72faa8ac2b75380511b32a2880945adb0c0362473f1b) during the creation of the tokens and many of these have been distributed into circulation. The complete breakdown of the distributions to date are below:\n\n\n![](https://i.imgur.com/g3K0zIc.png)\n\nThe HOP Community Multisig now has 6,157,401.72 HOP tokens available, or about 2 months of supply. At the current run rate, approximately 2,941,299.13 HOP is distributed each month, which equates to approximately 3.53% of the total HOP supply each year.\n\nThis RFC hopes to achieve consensus that the HOP Community Multisig should be refilled at this time in order to continue efficient distributions from the HOP DAO into the hands of HOP stakeholders.\n\n### Actions\n\nIf consensus is achieved, this proposal will send 11,765,196.52 HOP from the HOP DAO to the HOP Community Multisig. This number represents roughly 4 months of distribution and approximately 1.16% of the total HOP supply, capping the liabilities of the HOP Community Multisig.\n\nPer [HIP-15](https://snapshot.org/#/hop.eth/proposal/0x6b5136469fd7b1478c0e10b95e30e8645a1cea8bb49cabeed59a312264b518f0), this distribution, as well as future distributions to refill the multisig, will target approximately 4 months worth of DAO expenses, refilled via on-chain governance vote every other month.\n\nThe calculation of 11,765,196.52 HOP was achieved by looking at the cumulative distribution of the prior two months and using that to approximate the next 4 months’ expenses. Any major, forward-looking changes, such as newly accepted & forthcoming distributions or the ending of incentive programs, should be taken into consideration when calculating this number for future refills.\n\nShould the RFC be widely accepted, a delegate will conduct a temperature check on Snapshot and a subsequent on-chain proposal. If there are no material changes to the structure, future refills of this nature will bypass an RFC and proceed directly to a Snapshot vote.\n\nThe [Snapshot vote](https://snapshot.org/#/hop.eth/proposal/0x3e81e9581f48b150787a5160c3dfc65d4947ff4206e6cdca053d16da0bc60a77) has passed, and now the proposal moves to a Tally vote to be executed on-chain. \n\n```\nVoting Options:\n* Yes\n* No\n* Abstain\n```\n \n",
          "status": "ACCEPTED",
          "createdAt": "2023-02-23T21:16:23.000Z",
          "proposalNativeId": "0xed8bdb5895b8b7f9fdb3c087628fd8410e853d48-proposal-232477",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": null
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[RFC] Refill The HOP Community Multisig with Funds from the HOP DAO",
          "status": "ACCEPTED",
          "createdAt": "2023-02-11T21:12:33.000Z",
          "proposalNativeId": "0x3e81e9581f48b150787a5160c3dfc65d4947ff4206e6cdca053d16da0bc60a77",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"Yes\",\"No\",\"Abstain\"]"
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-17] Deploy Hop bridge functionality on the ConsenSys zkEVM rollup",
          "status": "ACCEPTED",
          "createdAt": "2023-01-26T00:21:44.000Z",
          "proposalNativeId": "0x29c0205077e5041a00b602c2e71a1b2ca5d84e2f7b4f02d2c7102948d4ffc783",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"Yes\",\"No\",\"Abstain\"]"
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-16] Fees and a Commitment to Public Goods Funding",
          "status": "ACCEPTED",
          "createdAt": "2023-01-19T04:57:32.000Z",
          "proposalNativeId": "0xf1bf9327ad089d25e949b044d1673501acbeef96f1657d0e79b89fe365983595",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": null,
          "voteChoice": null,
          "choices": null
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-15] Engage Authereum Labs as Service Provider",
          "status": "ACCEPTED",
          "createdAt": "2023-01-19T04:56:01.000Z",
          "proposalNativeId": "0x6b5136469fd7b1478c0e10b95e30e8645a1cea8bb49cabeed59a312264b518f0",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": null,
          "voteChoice": null,
          "choices": null
      },
      {
          "organizationId": "f50de02c-382c-4527-b462-eaf4ac538c18",
          "title": "[HIP-14] Hop Protocol Roadmap",
          "status": "ACCEPTED",
          "createdAt": "2023-01-19T04:54:29.000Z",
          "proposalNativeId": "0x77dfa74f2fa447137b13d8e5a6faaa7c9f2d1a23f86e837fb6e0aea84902c82f",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": null,
          "voteChoice": null,
          "choices": null
      }
  ],
  "b29f3be3-d4c7-4401-92cd-73390f09816b": [
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "D2.finance STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T01:13:21.000Z",
          "proposalNativeId": "0x3f43c84a863eb88afd0bc593290cd4bb8a9ce90f8105c15cf1b0252866e3e051",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": false,
          "voteChoice": 3,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Rodeo Finance STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T01:01:33.000Z",
          "proposalNativeId": "0x4af0134cf2fad93af6f255882f4c38847e38cfa083aaa29e37e9a9a669b7d913",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Furucombo STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T01:01:04.000Z",
          "proposalNativeId": "0x1281a058914a2fcf91b45098a8be812da69fc4fe46158a07ed02225f37816818",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "ALAYA STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T01:00:33.000Z",
          "proposalNativeId": "0xb387ad47abdbf95c2c3f285db3dd3ce8cf2bab4288250c813a38d3a89089303d",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 2,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Thetanuts STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T01:00:01.000Z",
          "proposalNativeId": "0x61a4311cc427b02bf6f69a7f1d262b7a50998d37916564934194fb1eefee8a6e",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Beefy STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:59:29.000Z",
          "proposalNativeId": "0x7572d14df9604571fa6b58827c7512d94fca09f24541202cd4a976f822df8f54",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "HMX STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T00:55:37.000Z",
          "proposalNativeId": "0x6c4a78cb00f613cdfe49e47c17cb83e74776873a789ea2553c0b1014b0288ae1",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": false,
          "voteChoice": 3,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Perennial Finance STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:55:00.000Z",
          "proposalNativeId": "0x97f1ffcf2fb02b4adb55807641dc1f8aecceeeed7c446dfebbd63dbf2a636fa4",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Angle Protocol STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:54:18.000Z",
          "proposalNativeId": "0x54aef9378fdb7addaa3b0ec0fbeb7884b4652cff4023abec69f2ac4ac6babdc0",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Galxe STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:53:24.000Z",
          "proposalNativeId": "0xc99797495dabf5d69b46e583cf90e4bc2858eda07886f6bbbc2ddc40aa219869",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Wombex Finance STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T00:52:44.000Z",
          "proposalNativeId": "0x64ae7b7e4670f045588f81fcd4f35822aebaa02c3b4bc459696e55ed73cb5536",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 2,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Arrakis Finance STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:50:19.000Z",
          "proposalNativeId": "0x9abaac4d02728258a41777cce8c1803403072d8116306f95317f89a7cb181ec6",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Socket STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:49:17.000Z",
          "proposalNativeId": "0xe213f7a4e3093ac66bc614b12c83976d5b075b58380edccdffd58349b82a0a1f",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": null,
          "voteChoice": null,
          "choices": null
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Stargate Finance STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:48:38.000Z",
          "proposalNativeId": "0x0d9fd9f880615a320fa1294264d317228f0479d7f7f146f5c9683f1cb27f814b",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 1,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Tally STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:47:46.000Z",
          "proposalNativeId": "0x3860f7700f2e1d6433b013114b0ff95088c09026b39321ca92c8a55fdb33d1e0",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": null,
          "voteChoice": null,
          "choices": null
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Prime Protocol STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:46:51.000Z",
          "proposalNativeId": "0x871bf6b01d337db95c1ac85e6ea4c4d16391bcfa3d5091453f2bc5ff467a50cc",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": false,
          "voteChoice": 3,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "LOGX STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T00:45:47.000Z",
          "proposalNativeId": "0x6709edbc057b630e80c8bd6dcd4bb5a159256a03a1aaf8e8c25bb3f523fe52a0",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": false,
          "voteChoice": 3,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Frax Finance STIP Proposal - Round 1",
          "status": "ACCEPTED",
          "createdAt": "2023-10-06T00:44:58.000Z",
          "proposalNativeId": "0xce4a31c915826aa857ab730d8b84e9c5bdd171e0c10f06b70cfffdadbf554b6c",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": null,
          "voteChoice": null,
          "choices": null
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Webacy STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T00:44:09.000Z",
          "proposalNativeId": "0xa5cd3d931a2884bd6aa6763699b2c52c6bb5129eefb0d33d930491d6375294f0",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": false,
          "voteChoice": 3,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      },
      {
          "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "CRYPTEX STIP Proposal - Round 1",
          "status": "REJECTED",
          "createdAt": "2023-10-06T00:42:41.000Z",
          "proposalNativeId": "0x7c75d57e2539be2e764dcad851b26fc38b300af3526b179f0146fb3fc139532e",
          "proposerId": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "successfulVote": true,
          "voteChoice": 2,
          "choices": "[\"For\",\"Against\",\"Abstain\"]"
      }
  ]
};
